import { Injectable } from "@angular/core";
import { OrganizationService, IOrganization } from "@main/companies";
import { IPermission } from "@main/permissions/permission";
import { PermissionService } from "@main/permissions/permission.service";
import { UserService } from ".";
import { IGoverningBody } from "@project/governingbody/governingbody";
import { GoverningBodyService } from "@project/governingbody/governingbody.service";
import { UserHelperService } from "./user-helper.service";
import { DefaultPermissions } from "./default-permissions";

declare type UserEditData = {
    organizationFormPermissions: { [orgId: string]: IPermission[] };
    defaultPermissions: DefaultPermissions;
    permissionsDependencies: { [permission: string]: string[][] };
    governingBodies?: IGoverningBody[];
};

@Injectable({
    providedIn: "root"
})
export class UserEditDataService {
    constructor(
        private userService: UserService,
        private permissionService: PermissionService,
        private governingBodyService: GoverningBodyService,
        private userHelperService: UserHelperService
    ) {}

    async loadUserEditData(userId: string): Promise<UserEditData> {
        const govBodies =
            this.userHelperService.isMiProAdmin || this.userHelperService.isSuperAdmin
                ? this.governingBodyService.getAllGovBody()
                : Promise.resolve(<IGoverningBody[]>undefined);

        const [organizationFormPermissions, defaultPermissions, permissionsDependencies, governingBodies] = await Promise.all([
            this.permissionService.getUserOrganizationsFormPermissions(userId),
            this.userService.getDefaultPermissions(),
            this.userService.getPermissionsDependencies(),
            govBodies
        ]);

        return {
            organizationFormPermissions,
            defaultPermissions,
            permissionsDependencies,
            governingBodies
        };
    }
}
